import { render, staticRenderFns } from "./bonus-rules.vue?vue&type=template&id=33c2d861"
import script from "./bonus-rules.vue?vue&type=script&lang=js"
export * from "./bonus-rules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/bonus-rules/bonus-rules.vue
// module id = Ba6W
// module chunks = 0